import publicRoutes from './publicRoutes';
import privateRoutes from './privateRoutes';

export default [
  ...publicRoutes,
  ...privateRoutes
];
